var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"worldmap",staticClass:"worldmap-inner-container",attrs:{"itemid":"worldmap-content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }